export default "__VITE_ASSET__BbU7yk1h__"